import React from "react";
import { CURRENCY_TYPES } from "../../services/currencyService";
import "../../styles/currency-selector.css";

// Currency combo box paired with a "reload rates" refresh button.
// - value: selected currency code
// - onChange(code): called when the user picks a currency
// - onRefresh(): called when the refresh button is clicked
// - refreshing: shows a spinning state and disables the button
// - disabled: disables the select (e.g. read-only pages)
const CurrencySelector = ({
  value = "USD",
  onChange,
  onRefresh,
  refreshing = false,
  disabled = false,
}) => {
  return (
    <div className="currency-selector">
      <select
        className="currency-selector-select"
        value={value}
        onChange={(e) => onChange && onChange(e.target.value)}
        disabled={disabled}
      >
        {CURRENCY_TYPES.map((code) => (
          <option key={code} value={code}>
            {code}
          </option>
        ))}
      </select>
      {onRefresh && (
        <button
          type="button"
          className="currency-selector-refresh"
          onClick={onRefresh}
          disabled={refreshing}
          title="Reload latest conversion rates"
          aria-label="Reload latest conversion rates"
        >
          <span className={`currency-refresh-icon${refreshing ? " spinning" : ""}`}>
            ↻
          </span>
        </button>
      )}
    </div>
  );
};

export default CurrencySelector;
